export default __webpack_public_path__ + "static/media/om_logo.4d898aab.svg";